module.exports = __webpack_public_path__ + "img/interify.7d9eb17f.svg";